(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ql-hot-spots"] && !Shopify.designMode) return;
  try {
    
var HotSpots = class extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init() {
    let oMask = this.querySelector(".h-p-mask")
    let oSpots = this.querySelectorAll(".h-s-btn")
    let oContains = this.querySelectorAll(".h-s-item-main")
    let oCloseBtn = this.querySelectorAll(".h-s-close-btn")
    let oMobileMain = this.querySelector(".h-s-mobile-main")
    let oMobileContent = this.querySelectorAll(".h-s-mb-content")
    function show (i) {
      let current = oSpots[i].getAttribute("show")
      if (current=='true') {
        hide()
        return  
      }
      oMask.setAttribute("show", 'true')
      oSpots.forEach(t => {
        t.setAttribute("show", false)
      });
      oSpots[i].setAttribute("show", 'true')
      oContains.forEach(t => {
        t.setAttribute("show", false)
      });
      oContains[i].setAttribute("show", 'true')
      oMobileContent.forEach(t => {
        t.setAttribute("show", false)
      });
      oMobileContent[i].setAttribute("show", 'true')
      oMobileMain.setAttribute("show", 'true')
    }
    function hide () {
      oMask.setAttribute("show", false)
      oSpots.forEach(t => {
        t.setAttribute("show", false)
      });
      oContains.forEach(t => {
        t.setAttribute("show", false)
      });
      oMobileMain.setAttribute("show", 'false')
    }
    oMask.onclick = () => {
      hide()
    }
    oSpots.forEach((btn, i) => {
      btn.onclick = (e) => {
        show(i)
      };
    });
    oCloseBtn.forEach((btn, i) => {
      btn.onclick = (e) => {
        hide(i)
      };
    });
  }
}
if (!window.customElements.get("hot-spots")) {
  window.customElements.define("hot-spots", HotSpots);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ql-two-image-comparison"] && !Shopify.designMode) return;
  try {
    
class QlTwoImageComparison extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let imgcWrap = this.querySelector('.imgc-wrap')
    let imgcBox1 = this.querySelector('.imgc-box1')
    let imgcBtnWrap = this.querySelector('.imgc-btn-wrap')
    let imgcBtn = this.querySelector('.imgc-btn')
    let show_animation = this.getAttribute("show_animation") ? true : false

    imgcBtnWrap.addEventListener('mousedown', (e) => {
      let startX = e.clientX;
      let startLeft = imgcBtnWrap.offsetLeft;

      function onMouseMove(e) {
        let newLeft = startLeft + e.clientX - startX;
        if (newLeft < 0) newLeft = 0;
        if (newLeft > imgcWrap.clientWidth) newLeft = imgcWrap.clientWidth;
        let percent = newLeft / imgcWrap.clientWidth * 100
        // if (percent < 3) percent = 3;
        // if (percent > 97) percent = 97;
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;
        imgcBtnWrap.style.left = `${percent}%`;
        imgcBox1.style.clipPath = `inset(0px 0px 0px ${percent}%)`;
      }
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', () => {
        document.removeEventListener('mousemove', onMouseMove);
      }, { once: true });
    });

    imgcBtnWrap.addEventListener('touchstart', (e) => {
      e = e.touches[0]
      let startX = e.clientX;
      let startLeft = imgcBtnWrap.offsetLeft;

      function onMouseMove(e) {
        e = e.touches[0]
        let newLeft = startLeft + e.clientX - startX;
        if (newLeft < 0) newLeft = 0;
        if (newLeft > imgcWrap.clientWidth) newLeft = imgcWrap.clientWidth;
        let percent = newLeft / imgcWrap.clientWidth * 100
        // if (percent < 3) percent = 3;
        // if (percent > 97) percent = 97;
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;
        imgcBtnWrap.style.left = `${percent}%`;
        imgcBox1.style.clipPath = `inset(0px 0px 0px ${percent}%)`;
      }
      document.addEventListener('touchmove', onMouseMove);
      document.addEventListener('touchend', () => {
        document.removeEventListener('touchmove', onMouseMove);
      }, { once: true });
    });

    if (show_animation) {
      let observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            imgcBox1.classList.add('imgc-box-animation');
            imgcBtnWrap.classList.add('imgc-btn-animation');
            observer.unobserve(imgcWrap);
          }
        });
      }, { threshold: 0.1 });
      observer.observe(imgcWrap);
    }
  }
}
if (!customElements.get('ql-two-image-comparison')) {
  customElements.define('ql-two-image-comparison', QlTwoImageComparison);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ql-video-slider"] && !Shopify.designMode) return;
  try {
    
class VideoSlider extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init () {
    let sectionId = this.getAttribute("section-id")
    let play_type = this.getAttribute("play_type")
    let className = `.swiper-${sectionId}`
    const swiper = new Swiper(className, {
      loop: false,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.qvs-next',
        prevEl: '.qvs-prev',
      }
    });
    // swiper.on('slideChange', () => {
    //   let oVideos = this.querySelectorAll('.qvs-slider-video');
    //   console.log(oVideos)

    //   oVideos.forEach(v => {
    //     v.play()
    //   })
    // })
    if (play_type == '1') {
      let oItems = this.querySelectorAll('.qvs-slider-a');
      let oVideos = this.querySelectorAll('.qvs-big-video');
      let oMask = this.querySelector('.qvs-mask');
      let oFull = this.querySelectorAll('.qvs-full-box');
      let oClose = this.querySelector('.qvs-mask-close');
      let index = 0

      oItems.forEach((item, i) => {
        item.addEventListener("click", () => {
          let url = item.getAttribute("data-url");
          if (url) {
            index = i
            oMask.setAttribute("show", "1")
            oFull.forEach(v => {
              v.setAttribute("show", "")
            })
            oFull[i].setAttribute("show", "1")
            // console.log(oFull[i])
            oVideos[i].play()
          }
        })
      })
      oClose.addEventListener("click", () => {
        oMask.setAttribute("show", "")
        oVideos[index].pause()
      })
    }
  }
}
if (!customElements.get('q-video-slider')) {
  customElements.define('q-video-slider', VideoSlider);
}

  } catch(e) { console.error(e); }
})();
})();
